import Link from 'next/link';
import { ReactElement, useEffect, useState } from 'react';
import React from 'react';
import Pagination, { PaginationRenderItemParams } from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import Head from 'next/head';

interface PageLinkProps extends PaginationRenderItemParams {
  href: string;
}

const PageLink = React.forwardRef<HTMLAnchorElement, PageLinkProps>(
  ({ href, children, ...rest }, ref) => (
    <Link href={href}>
      <a {...rest} ref={ref}>
        {children}
      </a>
    </Link>
  )
);

PageLink.displayName = 'PageLink';

export default function MyPagination({
  page,
  count,
  hrefFn,
  domain,
}: {
  page: number;
  count: number;
  hrefFn: (page: number) => string | undefined;
  domain: string;
}): ReactElement {
  const [size, setSize] = useState<'small' | 'medium' | undefined>();

  useEffect(() => setSize(window.innerWidth < 375 ? 'small' : 'medium'), []);

  return (
    <>
      <Head>
        {page > 1 && <link rel="prev" href={`https://${domain}${hrefFn(page - 1)}`} />}
        {page < count && <link rel="next" href={`https://${domain}${hrefFn(page + 1)}`} />}
      </Head>
      <Pagination
        page={page}
        count={count}
        size={size}
        className="flex justify-center my-10"
        renderItem={(item) => (
          <PaginationItem component={PageLink} href={hrefFn(item.page) || ''} {...item} />
        )}
      />
    </>
  );
}
